import PostType from '../typings/PostType';
import { GhostPostOrPage } from './ghost-interfaces';

const mapGhostPost = (post: GhostPostOrPage): PostType => ({
    type: 'research',
    slug: post.slug,
    title: post.title,
    featureImage: post.featureImage,
    publishedAt: post.published_at,
    publishedAtTimestamp: post.published_at ? Date.parse(post.published_at) / 1000 : 0,
    readingTime: post.reading_time,
    tags: post.tags,
    primaryTag: post.primary_tag,
    primaryAuthor: post.primary_author,
    customExcerpt: post.custom_excerpt,
    excerpt: post.excerpt,
});

export default mapGhostPost;
